/*
 * HELP-16113: Dynamic description for GoData Rollover plans.
 *
 * The GoData subscription description statically reads
 * "Unused data expires at the end of each 30 days." That is accurate for the
 * lower non-rollover variants (5GB, 10GB) but confusing on the Rollover
 * variants (25GB+). This swaps that one sentence to a rollover-friendly wording
 * whenever a "Rollover" variant is selected, and restores it otherwise.
 *
 * Scoped by the description wording itself (see main-product.liquid), so it only
 * runs on products that contain the sentence.
 */
(function () {
  'use strict';

  var EXPIRE = 'Unused data expires at the end of each 30 days.';
  var ROLLOVER = 'Unused data will roll over at the end of each 30 days for up to 6 months.';

  function updateDescription(container, isRollover) {
    var target = isRollover ? ROLLOVER : EXPIRE;
    var other = isRollover ? EXPIRE : ROLLOVER;
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf(other) !== -1) {
        node.nodeValue = node.nodeValue.replace(other, target);
      }
    }
  }

  function bindVariantListener() {
    jQuery(window).on('cc-variant-updated', function (event, data) {
      if (!data || !data.variant || !data.product) {
        return;
      }

      var title = data.variant.title || data.variant.name || '';
      var isRollover = /rollover/i.test(title);

      var area = document.querySelector(
        '.product-area[data-product-id="' + data.product.id + '"]'
      );
      if (area) {
        updateDescription(area, isRollover);
      }
    });
  }

  // Apply the correct wording on first paint. The cc-variant-updated event only
  // fires on variant change, so a page deep-linked to a Rollover variant (e.g. a
  // per-variant link in an email, ?variant=<id>) would otherwise show "expires"
  // until the shopper touched the selector. Read the pre-selected variant from
  // the server-rendered variant <select> and swap if it is a Rollover variant.
  function applyInitialState() {
    var areas = document.querySelectorAll('.product-area[data-product-id]');
    for (var i = 0; i < areas.length; i++) {
      var idSelect = areas[i].querySelector('select[name="id"]');
      var option = idSelect ? idSelect.options[idSelect.selectedIndex] : null;
      if (option && /rollover/i.test(option.textContent || '')) {
        updateDescription(areas[i], true);
      }
    }
  }

  applyInitialState();

  // jQuery is loaded async on this theme, so it is often undefined when this
  // deferred script runs. Wait for it to appear before binding, rather than
  // bailing out (which left the listener unbound and the swap never firing).
  if (typeof jQuery !== 'undefined') {
    bindVariantListener();
  } else {
    var attempts = 0;
    var timer = setInterval(function () {
      if (typeof jQuery !== 'undefined') {
        clearInterval(timer);
        bindVariantListener();
      } else if (++attempts > 100) {
        clearInterval(timer);
      }
    }, 50);
  }
})();
